import { Component, OnInit } from '@angular/core';
import { APIComplaintsService } from '../../_services/complaints/API-complaints';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver/src/FileSaver';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; 
import { $ModalManagerService } from 'src/app/_helpers/Modals/ModalManager.service';
const today = new Date();
@Component({
  selector: 'app-complaints-download',
  templateUrl: './complaints-download.component.html',
  styleUrls: ['./complaints-download.component.css']
})
export class ComplaintsDownloadComponent implements OnInit  {
  maxDate: Date = new Date();
  minDate: Date = new Date();
  exDate: string;
  endDate: string;
  status: string = "Open";
  constructor(private tc: APIComplaintsService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
   private db: $DBManagerService) { }
   complaintsDownloadForm: FormGroup;
  get f() { return this.complaintsDownloadForm.controls; }
  ngOnInit() {
    this.complaintsDownloadForm = this.fb.group({
      Date: ['', Validators.required],
 	  ToDate: ['', Validators.required],
      selectedOptions: ['', Validators.required],
	  selectedStatus: ['', Validators.required]
    })
	//console.log("today.getDate() ",today.getDate());
    this.minDate.setDate(today.getDate() - 30);
    this.maxDate.setDate(today.getDate());
  }
  
  onItemChange(val){
	  this.status = val.value;  
  }
//on click download function
onClickDownload()
{
  var selDate = new Date(this.complaintsDownloadForm.get('Date').value);
  var toDate = new Date(this.complaintsDownloadForm.get('ToDate').value); 
  
    this.exDate = selDate.getFullYear() + "-" + (selDate.getMonth()+1) + "-" +selDate.getDate();
	this.endDate = toDate.getFullYear() + "-" + (toDate.getMonth()+1) + "-" +toDate.getDate();
	
  var data={ 
    "Start_Date":this.exDate,
	"End_Date":this.endDate,
    "type":this.complaintsDownloadForm.get('selectedOptions').value,
	"status":this.status
  }
  console.log("the download data is",data);
  this.tc.downloadComplaints(data)
  .subscribe(r=>{
    var blob = new Blob([r], {type: 'text/csv' })
    const today = new Date();
    var ranvalue = today.getTime();
    var fileName = ranvalue+'.csv';
    saveAs(blob, fileName); 
   // saveAs(blob, "myFile.csv"); 
 console.log("downloading goes here",r);
  })
}



}
